import React, { useEffect, useRef, useState } from "react";
import { Link } from 'react-router-dom';
import axios from "axios";
import { BACKEND_URL } from "../common/Common";
import "../../pages/home-carousel-offer/HomeCarouselOffer.css"

import hayatin from '../../assets/images/hayatin.jpg';
import homeicon from '../../assets/home-images/homeicon.jpg';
import experienceicon from '../../assets/home-images/experienceicon.jpg';
import businessicon from '../../assets/home-images/businessicon.jpg';
import plusicon from '../../assets/home-images/plusicon.png';
import messageicon from '../../assets/home-images/messageicon.png';
import bellicon from '../../assets/home-images/bellicon.png';
import profileicon from '../../assets/home-images/profileicon.png';
import search from '../../assets/home-images/search.png';
import videos from '../../assets/home-images/videos.png';
import blogs from '../../assets/home-images/blogs.png';
import save from '../../assets/home-images/save.png';
import menu from '../../assets/home-images/menu.png';
import downarrow from '../../assets/home-images/downarrow.png';
import campopup from '../../assets/home-images/cam-popup.png';
import vidpopup from '../../assets/home-images/vid-popup.png';
import offerpopup from '../../assets/home-images/offer-popup.png';
import eventpopup from '../../assets/home-images/event-popup.png';
import spotlightpopup from '../../assets/home-images/spotlight-popup.png';
import carouselpopup from '../../assets/home-images/carouselpopup.png';

import samplepost from "../../assets/home carousel offer/samplepost.png";
import samplevideo from "../../assets/home carousel offer/samplevideo.png";
import samplecarousel from "../../assets/home carousel offer/samplecarousel.png";
import downarrowicon from '../../assets/categorylist/downarrowicon.png';


const HomeCarouselOffer = () => {
    const [postpopup, setPostpopup] = useState(false);
    const popupRef = useRef(null);
    const [activeTab, setActiveTab] = useState("Offers");
    const [selected, setSelected] = useState("post");
    const [open, setOpen] = useState(false);
    const [actionselected, setActionSelected] = useState("");
    const [selectedDate, setSelectedDate] = useState("");
    const [selectedEndDate, setSelectedEndDate] = useState("");
    const [couponcategoryopen, setCouponcategoryopen] = useState(false);
    const [couponcategoryselected, setCouponcategoryselected] = useState([]);
    const [categories, setCategories] = useState([]); // categories get api state

    const toggleSelect = (item) => {
        if (couponcategoryselected.includes(item)) {
            setCouponcategoryselected(
                couponcategoryselected.filter(x => x !== item)
            );
        } else {
            setCouponcategoryselected([...couponcategoryselected, item]);
        }
    };

    const handleDateChange = (e) => {
        const date = new Date(e.target.value);
        // Format date as dd / mm / yyyy
        const formattedDate = `${("0" + date.getDate()).slice(-2)} / ${(
            "0" +
            (date.getMonth() + 1)
        ).slice(-2)} / ${date.getFullYear()}`;
        setSelectedDate(formattedDate);
    };

    const handleEndDateChange = (e) => {
        const date = new Date(e.target.value);
        const formattedDate = `${("0" + date.getDate()).slice(-2)} / ${(
            "0" +
            (date.getMonth() + 1)
        ).slice(-2)} / ${date.getFullYear()}`;
        setSelectedEndDate(formattedDate);
    };

    const Radiocheckoptions = [
        { key: "post", label: "Post", img: samplepost },
        { key: "video", label: "Video", img: samplevideo },
        { key: "carousel", label: "Carousel", img: samplecarousel },
    ];

    const options = [
        "Book Now",
        "Book Table",
        "Book a Ticket",
        "Reserve a Table",
        "Get Deal",
        "Book Now",
        "Book Table",
        "Book a Ticket",
        "Reserve a Table",
        "Get Deal",

    ];


    const coupon_category_options = ["Food & Drinks", "Casual & Quick Bites", "Cafés & Treats", "Brunch & Buffets", "Business Lunch"]

    const fetchCategories = async () => {
        try {
            const response = await axios.get(`${BACKEND_URL}website/categories`);
            setCategories(response.data.data);
        } catch (error) {
            console.error("Error fetching categories:", error);
        }
    };

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (popupRef.current && !popupRef.current.contains(event.target)) {
                setPostpopup(false);
            }
        };

        if (postpopup) {
            document.addEventListener('mousedown', handleClickOutside);
        }

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [postpopup]);

    return (
        <div>
            <nav className="navbar">
                <div className="navbar-brand">
                    <a href="/">
                        <img src={hayatin} alt="hayatin" />
                    </a>
                </div>

                <div className="homepage-icons">
                    <Link to="/">
                        <img src={homeicon} alt="homeicon" />
                    </Link>

                    <Link to="/experience">
                        <img src={experienceicon} alt="experienceicon" />
                    </Link>
                    <Link to="/business-and-brands">
                        <img src={businessicon} alt="businessicon" />
                    </Link>
                </div>

                <div className="registerbtn-icons">
                    <div className="register-business">
                        <a href="https://www.hayatinapp.com/vendor/register" >
                            <button className="register-business-btn">
                                Register Your Business
                            </button>
                        </a>
                    </div>

                    <div className="notificationicons">
                        <img src={plusicon} alt="plusicon" onClick={() => setPostpopup(true)} />
                        <img src={messageicon} alt="messageicon" />
                        <img src={bellicon} alt="bellicon" />
                        <img src={profileicon} alt="profileicon" />
                    </div>

                </div>

            </nav>

            <div className="experience-main-layout">
                <aside className="left-section">
                    <div className="searchbox">
                        <img src={search} alt="search" />
                        <input type="text" placeholder="Search..." />
                    </div>
                    <div className="left-menu-content">
                        <div className="img-contentname">
                            <img src={videos} alt="videos" />
                            <p>Videos for you</p>
                        </div>
                        <div className="img-contentname">
                            <img src={blogs} alt="blogs" />
                            <p>Blogs</p>
                        </div>
                        <div className="img-contentname">
                            <img src={save} alt="save" />
                            <p>Saved</p>
                        </div>
                        <div className="img-contentname">
                            <img src={profileicon} alt="profileicon" />
                            <p>Profile</p>
                        </div>
                        <div className="img-contentname">
                            <img src={plusicon} alt="plusicon" />
                            <p>Post</p>
                        </div>
                        <div className="img-contentname">
                            <img src={menu} alt="menu" />
                            <p>Menu</p>
                        </div>
                    </div>
                    <div className="divider-line"></div>
                    <div className="left-bottom-links">
                        <div className="left-bottom1">
                            <a href="/about">About</a>
                            <a href="#BusinessPro">Business Pro</a>
                        </div>
                        <div className="left-bottom1">
                            <a href="#help-center">Help Center</a>
                            <a href="#FAQ">FAQ</a>
                            <a href="#Careers">Careers</a>
                        </div>
                        <div className="left-bottom1">
                            <div className="content-arrow">
                                <Link to="/merchantagreement" className="privacy-link">
                                    <span>Privacy & Terms</span>
                                    <img src={downarrow} alt="down arrow" />
                                </Link>
                            </div>
                            <div className="content-arrow">
                                <a href="#Languages">Language</a>
                                <img src={downarrow} alt="downarrow" />
                            </div>
                        </div>
                    </div>
                </aside>
                <main className="experience-middle-section">
                    <div className="home-carousel-offer-container">
                        <div className="offer-event-active-tab-div">
                            <p
                                className={activeTab === "Offers" ? "active-tab" : ""}
                                onClick={() => setActiveTab("Offers")}
                            >
                                Offers
                            </p>

                            <p
                                className={activeTab === "Event" ? "active-tab" : ""}
                                onClick={() => setActiveTab("Event")}
                            >
                                Event
                            </p>
                        </div>

                        <div className="radio-wrapper">
                            {Radiocheckoptions.map((opt) => (
                                <label key={opt.key} className="radio-block">

                                    {/* ← Horizontal Row (radio + text) */}
                                    <div className="radio-row">
                                        <input
                                            type="radio"
                                            name="contentType"
                                            value={opt.key}
                                            checked={selected === opt.key}
                                            onChange={() => setSelected(opt.key)}
                                        />
                                        <span className="radio-text">{opt.label}</span>
                                    </div>

                                    {/* ↓ Image below */}
                                    <img src={opt.img} alt={opt.label} className="radio-img" />
                                </label>
                            ))}
                        </div>


                        <div className="all-input-box-container">
                            <div className="center-container">
                                <div className="action-select-wrapper">
                                    <p>Action Type</p>

                                    {/* SELECT BOX */}
                                    <div
                                        className="action-select-box"
                                        onClick={() => setOpen(!open)}
                                    >
                                        <span>{actionselected || "Select Action"}</span>
                                        <img src={downarrowicon} alt="down" className="down-arrow-icon" />
                                    </div>

                                    {/* DROPDOWN */}
                                    {open && (
                                        <div className="action-dropdown">
                                            {options.map((item, idx) => (
                                                <div
                                                    key={idx}
                                                    className="action-option"
                                                    onClick={() => {
                                                        setActionSelected(item);
                                                        setOpen(false);
                                                    }}
                                                >
                                                    {item}
                                                </div>
                                            ))}
                                        </div>
                                    )}
                                </div>
                            </div>

                            <div className="start-end-date-container">
                                <div className="date-picker-container">
                                    <p>Start Date</p>
                                    <input
                                        type="date"
                                        className="date-picker-input"
                                        onChange={handleDateChange}
                                        value={
                                            selectedDate
                                                ? new Date(
                                                    selectedDate.split(" / ").reverse().join("-")
                                                ).toISOString().split("T")[0]
                                                : ""
                                        }
                                    />
                                </div>

                                <div className="date-picker-container">
                                    <p>End Date</p>
                                    <input
                                        type="date"
                                        className="date-picker-input"
                                        onChange={handleEndDateChange}
                                        value={
                                            selectedEndDate
                                                ? new Date(
                                                    selectedEndDate.split(" / ").reverse().join("-")
                                                ).toISOString().split("T")[0]
                                                : ""
                                        }
                                    />
                                </div>
                            </div>

                            <div className="coupons-container">
                                <div className="action-select-wrapper">
                                    <p>Coupons</p>

                                    {/* SELECT BOX */}
                                    <div
                                        className="category-select-box"
                                        onClick={() => setCouponcategoryopen(!couponcategoryopen)}
                                    >
                                        {couponcategoryselected.length === 0 && <span>Select Category</span>}

                                        {couponcategoryselected.length === 1 && (
                                            <span>{couponcategoryselected[0]}</span>
                                        )}

                                        {couponcategoryselected.length > 1 && (
                                            <span className="selected-summary">
                                                {couponcategoryselected[0]}
                                                <span className="plus-count">
                                                    <span className="plus-count-number">
                                                        {couponcategoryselected.length - 1}
                                                    </span>
                                                </span>
                                            </span>
                                        )}

                                        <img src={downarrowicon} alt="down" className="down-arrow-icon" />
                                    </div>

                                    {/* DROPDOWN */}
                                    {couponcategoryopen && (
                                        <div className="category-dropdown">
                                            {coupon_category_options.map((item, idx) => (
                                                <div
                                                    key={idx}
                                                    className={`category-option ${couponcategoryselected.includes(item) ? "selected" : ""
                                                        }`}
                                                    onClick={() => toggleSelect(item)}
                                                >
                                                    {item}
                                                </div>
                                            ))}
                                        </div>
                                    )}
                                </div>

                                <div className="action-select-wrapper">
                                    <p></p>
                                    <div className="category-select-box coupons-select">
                                        <span>Select Coupons</span>
                                        <img src={downarrowicon} alt="down" className="down-arrow-icon" />
                                    </div>
                                </div>


                            </div>
                            <div className="description-container">
                                <div className="action-select-wrapper">
                                    <p>Description</p>

                                    <div className="description-box">
                                        <textarea
                                            className="description-input"
                                            placeholder="Write Description"
                                        ></textarea>
                                    </div>
                                </div>
                            </div>
                        </div>


                        <div className="preview-carousel-buttons">
                            <button className="preview-btn">Preview</button>
                            <button className="share-btn">Share Carousel</button>
                        </div>

                    </div>
                </main>

            </div>

            {postpopup && (
                <div className="popup-overlay" onClick={() => setPostpopup(false)}>
                    <div className="popup-box" ref={popupRef} onClick={(e) => e.stopPropagation()}>
                        <div className="popup-options">
                            <Link to="/HomeCarouselOffer" className="remove-underline">
                                <div className="popup-item">
                                    <img src={campopup} alt="Post" />
                                    <p>Post</p>
                                </div>
                            </Link>

                            <div className="popup-item">
                                <img src={vidpopup} alt="Video" />
                                <p>Video</p>
                            </div>

                            <div className="popup-item">
                                <img src={carouselpopup} alt="Carousel" />
                                <p>Carousel</p>
                            </div>

                            <div className="popup-item">
                                <img src={offerpopup} alt="Offer" />
                                <p>Offer</p>
                            </div>

                            <div className="popup-item">
                                <img src={spotlightpopup} alt="Spotlight" />
                                <p>Spotlight</p>
                            </div>

                            <div className="popup-item">
                                <img src={eventpopup} alt="Event" />
                                <p>Event</p>
                            </div>

                        </div>
                    </div>
                </div>
            )}




        </div>



    )
}

export default HomeCarouselOffer